module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_48.8a16db7d.jpg";